/* tslint:disable */
import {
  Payee
} from '../index';

declare var Object: any;
export interface PayeePCIDSSInterface {
  "payee_id": number;
  "store_card_data"?: boolean;
  "storage_computer_based"?: boolean;
  "storage_hardcopy"?: boolean;
  "unique_password"?: boolean;
  "password_protected_files"?: boolean;
  "password_refresh"?: boolean;
  "encrypt_card_number"?: boolean;
  "card_number"?: boolean;
  "expiry_date"?: boolean;
  "cvv"?: boolean;
  "kept_lock"?: boolean;
  "label_discreet"?: boolean;
  "mask_card_number"?: boolean;
  "limited_access_file"?: boolean;
  "edc_connected_network"?: boolean;
  "swipe_other_mbb_terminal"?: boolean;
  "pos_name"?: string;
  "pos_version"?: string;
  "pos_vendor_name"?: string;
  "pos_comply_PADSS"?: boolean;
  "id"?: number;
  "created_at"?: Date;
  "updated_at"?: Date;
  "deletedAt"?: Date;
  "isDeleted": boolean;
  payee?: Payee;
}

export class PayeePCIDSS implements PayeePCIDSSInterface {
  "payee_id": number;
  "store_card_data": boolean;
  "storage_computer_based": boolean;
  "storage_hardcopy": boolean;
  "unique_password": boolean;
  "password_protected_files": boolean;
  "password_refresh": boolean;
  "encrypt_card_number": boolean;
  "card_number": boolean;
  "expiry_date": boolean;
  "cvv": boolean;
  "kept_lock": boolean;
  "label_discreet": boolean;
  "mask_card_number": boolean;
  "limited_access_file": boolean;
  "edc_connected_network": boolean;
  "swipe_other_mbb_terminal": boolean;
  "pos_name": string;
  "pos_version": string;
  "pos_vendor_name": string;
  "pos_comply_PADSS": boolean;
  "id": number;
  "created_at": Date;
  "updated_at": Date;
  "deletedAt": Date;
  "isDeleted": boolean;
  payee: Payee;
  constructor(data?: PayeePCIDSSInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PayeePCIDSS`.
   */
  public static getModelName() {
    return "PayeePCIDSS";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PayeePCIDSS for dynamic purposes.
  **/
  public static factory(data: PayeePCIDSSInterface): PayeePCIDSS{
    return new PayeePCIDSS(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PayeePCIDSS',
      plural: 'payeePCIDSSs',
      path: 'payeePCIDSSs',
      idName: 'id',
      properties: {
        "payee_id": {
          name: 'payee_id',
          type: 'number'
        },
        "store_card_data": {
          name: 'store_card_data',
          type: 'boolean'
        },
        "storage_computer_based": {
          name: 'storage_computer_based',
          type: 'boolean'
        },
        "storage_hardcopy": {
          name: 'storage_hardcopy',
          type: 'boolean'
        },
        "unique_password": {
          name: 'unique_password',
          type: 'boolean'
        },
        "password_protected_files": {
          name: 'password_protected_files',
          type: 'boolean'
        },
        "password_refresh": {
          name: 'password_refresh',
          type: 'boolean'
        },
        "encrypt_card_number": {
          name: 'encrypt_card_number',
          type: 'boolean'
        },
        "card_number": {
          name: 'card_number',
          type: 'boolean'
        },
        "expiry_date": {
          name: 'expiry_date',
          type: 'boolean'
        },
        "cvv": {
          name: 'cvv',
          type: 'boolean'
        },
        "kept_lock": {
          name: 'kept_lock',
          type: 'boolean'
        },
        "label_discreet": {
          name: 'label_discreet',
          type: 'boolean'
        },
        "mask_card_number": {
          name: 'mask_card_number',
          type: 'boolean'
        },
        "limited_access_file": {
          name: 'limited_access_file',
          type: 'boolean'
        },
        "edc_connected_network": {
          name: 'edc_connected_network',
          type: 'boolean'
        },
        "swipe_other_mbb_terminal": {
          name: 'swipe_other_mbb_terminal',
          type: 'boolean'
        },
        "pos_name": {
          name: 'pos_name',
          type: 'string'
        },
        "pos_version": {
          name: 'pos_version',
          type: 'string'
        },
        "pos_vendor_name": {
          name: 'pos_vendor_name',
          type: 'string'
        },
        "pos_comply_PADSS": {
          name: 'pos_comply_PADSS',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "created_at": {
          name: 'created_at',
          type: 'Date'
        },
        "updated_at": {
          name: 'updated_at',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date'
        },
        "isDeleted": {
          name: 'isDeleted',
          type: 'boolean',
          default: false
        },
      },
      relations: {
        payee: {
          name: 'payee',
          type: 'Payee',
          model: 'Payee',
          relationType: 'belongsTo',
                  keyFrom: 'payee_id',
          keyTo: 'id'
        },
      }
    }
  }
}
